import { UnstyledButton as MantineUnstyledButton } from "@mantine/core";

export const UnstyledButton = MantineUnstyledButton;
